import axios from 'axios'

export default {
    limitYear () {
        return axios.get('/api/event/limit-year');
    },

    find (eventId) {
        return axios.get('/api/events/' + eventId);
    },

    search (query, page = null, paginationSize = null) {
        return axios.post('/api/events/search', {
            query: query,
            page: page,
            pagination_size: paginationSize
        })
    },

    all (page = 1) {
        return axios.get('/api/event/all' + "?page=" + page);
    },

    forYear (startDate, endDate) {
        return axios.get('/api/event/for-year' + "?startYear=" + startDate + "&endYear=" + endDate);
    },

    random () {
        return axios.get('/api/event/random');
    },

    randoms (limit=1) {
        return axios.get('/api/event/randoms' + "?limit=" + limit);
    },
}
